<template>
    <div class="vm-icon-pay" :class="name">
        <div class="icon-box">
            <pic class="icon-paypal" width="32" v-if="name == 'paypal'" :src="`${GL.PIC_HOST}/static/img/paypal.png`"/>
            <template v-else>
                <icon :name="name"></icon>
            </template>
            <!-- <pic class="icon-discount" v-if="name == 'alipay' && !is_hide_lijian" :src="`${GL.PIC_HOST}/static/img/alipay-discount-11.png`"/> -->
            <pic class="icon-discount" v-if="name == 'alipay' && !is_hide_lijian" :src="`${GL.PIC_HOST}/static/img/alipay-discount.png`"/>
            <div v-if="!is_no_text" class="text-box">
                <div>{{ text }}</div>
                <div class="tip" v-if="name == 'wxpay' && (GL.ENV.is_xiaoyuzhou)">
                    {{$t('c.IconPay.text1')}}
                </div>
            </div>
        </div>
        <div v-if="is_tuijian" class="tuijian-text flex-box flex-center fs12 lh1">{{$t('c.IconPay.text2')}}</div>
        <!-- <pic
            class="tuijian"
            v-if="is_tuijian"
            type="2"
            width="40"
            :src="`${this.GL.PIC_HOST}/static/img/tuijian.png`"
        ></pic> -->
        <div v-if="!is_no_text" class="text-box mt8">{{ text }}</div>
        <div class="disable-over"></div>
    </div>
</template>

<script>
export default {
    name: "icon-pay",
    props: {
        name: {
            type: String,
            default: "alipay",
        },
        is_no_text: {
            type: Boolean,
            default: false,
        },
        tuijian_type: {
            default: 'alipay',
        },
        is_hide_tuijian: {
            type: Boolean,
            default: false,
        },
        is_hide_lijian: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        text() {
            return {
                wxpay: this.$t('c.IconPay.text3'),
                alipay: this.$t('c.IconPay.text4'),
                paypal: this.$t('c.IconPay.text5'),
                bank: this.$t('c.IconPay.text6'),
            }[this.name];
        },
        is_bug_weibo() {
            return this.GL.ENV.is_bug_weibo;
        },
        is_tuijian() {
            // return !this.is_hide_tuijian && (this.GL.ENV.is_wechat && this.name == "wxpay") || (!this.GL.ENV.is_wechat);
            return (
                !this.is_hide_tuijian && this.name == this.tuijian_type && !this.GL.ENV.is_wechat
            );
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="stylus" scoped>
.vm-icon-pay {
  position: relative;

  .icon-paypal{
    width: 32px;
    height: 32px;
  }

  .icon-box {
    // width: px2rem(80);
    // height: px2rem(80);
    width: 86px;
    height: 86px;
    border: 1px solid $black-1;
    border-radius: px2rem(4);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    background: $white;

    .text-box {
      display: none;
      font-size: fs2rem(16);
    }
  }

  &.only-icon {
    .icon-box {
      width: auto;
      height: auto;
      border: 0;
      display: inline-block;
    }
  }

  .vm-icon {
    font-size: fs2rem(32);
  }

  .text-box {
    color: $black-5;
    text-align: center;
  }

  .disable-over {
    display: none;
  }

  &.disable {
    .disable-over {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: $black-05;
    }

    .icon-box {
      border-color: transparent;
    }
  }
  .icon-discount{
      position:absolute;
      right: 8px;
      bottom: -18px;
      width:63px;
  }

  .tuijian {
    position: absolute;
    width: 40px;
    // top: 50%;
    // transform: translateY(-50%);
    // bottom: -30px;
    right: 0;
    transform: translate(75%, 0%);
    bottom: 3px;
  }
  &.bank,
  &.paypal{
    .vm-icon {
    //   color: $blue-alipay;
    }

    &.on {
      .icon-box {
        border-color: $purple;
        box-shadow: 0 4px 10px $purple-2;
      }

      .text-box {
        color: $purple;
      }
    }
  }

  &.alipay {
    .vm-icon {
      color: $blue-alipay;
    }

    &.on {
      .icon-box {
        border-color: $blue-alipay;
        box-shadow: 0 4px 10px $blue-alipay-shadow;
      }

      .text-box {
        color: $blue-alipay;
      }
    }
  }

  &.wxpay {
    .vm-icon {
      color: $green-wxpay;
    }

    &.on {
      .icon-box {
        border-color: $green-wxpay;
        box-shadow: 0 4px 10px $green-wxpay-shadow;
      }

      .text-box {
        color: $green-wxpay;
      }
    }
  }
  .tuijian-text{
    background: #D74061;
    border-radius: 2px;
    color:$white;
    transform: translate(20%,-50%);
    top:0;
    right:0;
    position:absolute;
    width:32px;
    height:18px;
    z-index:1;
  }

  &.mq {
    @media (max-width: $width-mobile) {
    //   width: 100%;
      flex:1;
      margin-right:8px !important;
      &:last-child{
        margin-right:0px !important;
      }
      .icon-box {
        width: 100%;
        height: auto;
        justify-content: flex-start;
        box-sizing:border-box;
        padding:12px 16px;

        .vm-icon {
          // margin: 0 16px;
          font-size:16px;
        }
        .icon-paypal{
          width: 16px;
          height: 16px;
        }

        .text-box {
          display: block;
          text-align: left;
          margin-left:8px;
          white-space: nowrap;

          .tip {
            font-size: 12px;
            color: $black-5;
            position:absolute;
            right: 10px;
            bottom: 2px;
          }
        }
      }
      .icon-discount{
            position:absolute;
            right:10px;
            bottom: 2px;
        }

      .text-box {
        display: none;
      }

      .tuijian {
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
      }
    }
  }
}
</style>
